/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Box,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  AttachMoney,
  MoneyOff,
} from '@mui/icons-material';
import NoteAlt from '@mui/icons-material/NoteAlt';
import Visibility from '@mui/icons-material/Visibility';
import Grid from '@mui/material/Grid';
import AddEditBillableModal from '../../../pages/billing/components/AddEditBillableModal';
import AddEditModal from '../../../pages/horse/Horse/components/NotesCard/components/AddEditModal';
import {
  getBillableForTask,
  getNoteForTask,
} from '../../../redux/app/actions';
import { blueGrey } from '../../../utils/brandColors';
import BillableItem from '../../BillableItem';
import BillableStatusSelectComponent from '../../EnumSelects/BillableStatusSelect';
import ImportanceSelect from '../../EnumSelects/ImportanceSelect';
import NoteTypeSelect from '../../EnumSelects/NoteTypeSelect';
import NoteItemComponent from '../../NoteItem/NoteItem';

import {
  BILLABLE_PRICE_ERROR,
  isBillablePriceInput,
  isValidBillablePrice,
} from '../../../utils/billablePrice';

export function isNumber(n) { return !Number.isNaN(parseFloat(n)) && !Number.isNaN(n - 0) }

export const EditTaskEventDataComponent = ({
  onChange,
  taskEventData,
  completeDate,
  selectedEvent,
  barnHorse,
  showDivider,
  editAtStart = false,
}) => {
  const dispatch = useDispatch();

  const [editEventData, setEditEventData] = React.useState({});
  const eventData = useSelector((state) => state.eventData.eventData);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  // Associated billable for the horse on this task
  const horseBillable = useSelector((state) => state.app.billableForTask);
  const horseNote = useSelector((state) => state.app.noteForTask);

  const [changeBillable, setChangeBillable] = React.useState(false);
  const [changeNote, setChangeNote] = React.useState(false);
  const [openAddEditHorseBillableModal, setOpenAddEditHorseBillableModal] = React.useState(false);
  const [openAddEditHorseNoteModal, setOpenAddEditHorseNoteModal] = React.useState(false);

  React.useState(() => {
    setEditEventData(taskEventData);
    setOpenAddEditHorseBillableModal(false);
    setOpenAddEditHorseNoteModal(false);
  }, [taskEventData]);

  React.useState(() => {
    setChangeBillable(!horseBillable && editAtStart);
    setChangeNote(!horseNote && editAtStart);
  }, [editAtStart, horseBillable, horseNote]);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name
  const billableValue = (horseBillable && horseBillable.price)
    ?? (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)].value);
  const hasBillableValue = billableValue !== null
    && billableValue !== undefined;
  const billableStatus = (horseBillable && horseBillable.status) || (editEventData['Billable Status']
    && editEventData['Billable Status'].value) || 'Open';
  const billableReceivable = (horseBillable && horseBillable.receivabe) || (editEventData['Billable Receivable']
    && editEventData['Billable Receivable'].value) || 'yes';

  const noteValue = (horseNote && horseNote.note) || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)]
    && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)].value);
  const noteTypeValue = (horseNote && horseNote.type) || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]
    && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)].value);
  const noteImportanceValue = (horseNote && horseNote.importance)
    || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)].value);
  const noteClientViewableValue = (horseNote && horseNote.clientViewable)
    || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId)]
      && editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId)].value);

  const handleDataChange = (edId, type, value) => {
    const newEventData = {
      ...editEventData,
      [isNumber(edId)
        ? getEDNameFromId(edId)
        : edId]: {
        type,
        value,
      },
    }
    if (edId === 'Billable Receivable') {
      newEventData['Billable Status'] = {
        type: 'Text',
        value: value === 'no'
          ? 'Expense'
          : 'Open',
      }
    }
    setEditEventData(newEventData);
    onChange(newEventData);
  }

  /*
    If there is a billable task/note or if the task is in complete state,
    we always use the addEdit modals for billable and note
    Else we will use the eventdata on the task which will create the billable once the
    task is put in complete status
  */

  return (
    <Box>
      <ListItem divider={showDivider} dense>
        {(!billableValue || changeBillable) && <ListItemIcon><AttachMoney /></ListItemIcon>}
        {
          (onChange || billableValue)
            ? (
              <ListItemText>
                {
                  changeBillable
                    ? (
                      <Grid container spacing={1} alignItems="center">
                        <Grid size={12}>
                          <FormControlLabel
                            control={(
                              <Switch
                                size="small"
                                checked={hasBillableValue}
                                onChange={(e) => {
                                  handleDataChange(selectedBarn.barnMetadata.horseBillablePriceEventDataId, 'CurrencyUSD', e.target.checked
                                    ? '0.00'
                                    : null)
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            )}
                            sx={{ mb: 0 }}
                            label="Task Billing Transaction"
                          />

                        </Grid>
                        {
                          hasBillableValue && (
                            <Grid sx={{ width: 150 }}>
                              <TextField
                                size="small"
                                id="billable-price"
                                label="Amount"
                                value={billableValue ?? ''}
                                error={!isValidBillablePrice(billableValue)}
                                helperText={!isValidBillablePrice(billableValue) && BILLABLE_PRICE_ERROR}
                                onChange={(e) => {
                                  if (isBillablePriceInput(e.target.value)) {
                                    handleDataChange(selectedBarn.barnMetadata.horseBillablePriceEventDataId, 'CurrencyUSD', e.target.value)
                                  }
                                }}
                                InputProps={{
                                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                  inputMode: 'decimal',
                                }}
                              />
                            </Grid>
                          )
                        }
                        {
                          hasBillableValue && (
                            <Grid>
                              <FormControl fullWidth margin="none">
                                <InputLabel id="note-type-select-label">Type</InputLabel>
                                <Select
                                  labelId="horse-access-type-select-label"
                                  id="horse-access-type-select"
                                  value={billableReceivable || 'yes'}
                                  label="Type"
                                  size="small"
                                  onChange={(e) => {
                                    handleDataChange('Billable Receivable', 'YesNo', e.target.value)
                                  }}
                                >
                                  <MenuItem value="yes">
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <AttachMoney color="success" sx={{ mr: 1 }} />
                                      <Box>Billable</Box>
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value="no">
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <MoneyOff sx={{ mr: 1 }} />
                                      <Box>Expense</Box>
                                    </Box>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          )
                        }
                        {
                          hasBillableValue && (
                            <Grid sx={{ width: 150 }}>
                              {
                                (billableReceivable && billableReceivable !== 'no')
                                  ? (
                                    <BillableStatusSelectComponent
                                      value={billableStatus || 'Open'}
                                      size="small"
                                      includeExpenseOption={false}
                                      onChange={(e) => {
                                        handleDataChange('Billable Status', 'Text', e.target.value)
                                      }}
                                    />
                                  )
                                  : (
                                    <Box />
                                  )
                              }
                            </Grid>
                          )
                        }
                      </Grid>
                    )
                    : (
                      <Stack spacing={1}>
                        <Box>
                          {billableValue && (
                            <Paper
                              variant="outlined"
                              sx={{
                                flex: 1,
                                width: '100%',
                              }}
                              onClick={(e) => {
                                if (completeDate || (horseBillable && horseBillable.id)) {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setOpenAddEditHorseBillableModal(true);
                                } else {
                                  setChangeBillable(true)
                                }
                              }}
                            >
                              <BillableItem
                                billable={horseBillable || {
                                  status: billableStatus || 'Open',
                                  price: billableValue,
                                  receivable: billableReceivable,
                                  note: selectedEvent.name,
                                }}
                                containerProps={{ sx: { cursor: 'pointer' } }}
                                displayHorse={false}
                              />
                            </Paper>
                          )}
                          {(onChange && !horseBillable) && (
                            <Link
                              component="div"
                              variant="body2"
                              color="secondary"
                              underline="hover"
                              onClick={() => {
                                if (completeDate || (horseBillable && horseBillable.id)) {
                                  setOpenAddEditHorseBillableModal(true);
                                } else {
                                  setChangeBillable(true)
                                }
                              }}
                            >
                              {(horseBillable || (editEventData[getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)])
                                ? 'Modify'
                                : 'Add')}
                              {' '}
                              Billing Transaction
                            </Link>
                          )}
                        </Box>
                      </Stack>

                    )
                }
              </ListItemText>
            )
            : (
              <ListItemText primaryTypographyProps={{ fontWeight: 300 }}>No Billing Transaction</ListItemText>
            )
        }

      </ListItem>
      <ListItem dense>
        {(!noteTypeValue || changeNote) && <ListItemIcon><NoteAlt /></ListItemIcon>}
        {
          (onChange || noteTypeValue)
            ? (
              <ListItemText>
                {
                  changeNote
                    ? (
                      <Grid container spacing={1}>
                        <Grid size={12}>
                          <FormControlLabel
                            control={(
                              <Switch
                                size="small"
                                checked={!!noteTypeValue}
                                onChange={(e) => {
                                  const newEventData = {
                                    ...editEventData,
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? 'Note'
                                        : null,
                                    },
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteImportanceEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? 'Inform'
                                        : null,
                                    },
                                    [getEDNameFromId(selectedBarn.barnMetadata.horseNoteEventDataId)]: {
                                      type: 'Text',
                                      value: e.target.checked
                                        ? ''
                                        : null,
                                    },
                                  }
                                  setEditEventData(newEventData);
                                  onChange(newEventData);
                                }}
                                inputProps={{ 'aria-label': 'controlled' }}
                              />
                            )}
                            sx={{ mb: 0 }}
                            label="Task Horse Note"
                          />
                        </Grid>
                        {
                          noteTypeValue && (
                            <Grid>
                              <FormControlLabel
                                sx={{
                                  borderLeft: `1px solid ${'var(--blueGrey-unknown)'}`,
                                  m: 0,
                                  pl: 1,
                                }}
                                labelPlacement="start"
                                label={(
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >Client Viewable <Visibility color="primary" sx={{ ml: 1 }} />
                                  </Box>
                                )}
                                control={(
                                  <Switch
                                    size="small"
                                    checked={noteClientViewableValue && noteClientViewableValue === 'Yes'}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteClientViewableEventDataId, 'YesNo', e.target.checked
                                        ? 'Yes'
                                        : 'No')
                                    }}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                  />
                                )}
                                style={{ '--blueGrey-unknown': blueGrey[50] }}
                              />
                            </Grid>
                          )
                        }
                        {
                          noteTypeValue && (
                            <Grid>
                              <Grid container spacing={2}>
                                <Grid>
                                  <NoteTypeSelect
                                    value={noteTypeValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteTypeEventDataId, 'Text', e.target.value)
                                    }}
                                  />
                                </Grid>
                                <Grid>
                                  <ImportanceSelect
                                    value={noteImportanceValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteImportanceEventDataId, 'Text', e.target.value)
                                    }}
                                  />
                                </Grid>
                                <Grid>
                                  <TextField
                                    sx={{ minWidth: 250 }}
                                    id="horse-note"
                                    size="small"
                                    multiline
                                    maxRows="3"
                                    label="Note"
                                    value={noteValue}
                                    onChange={(e) => {
                                      handleDataChange(selectedBarn.barnMetadata.horseNoteEventDataId, 'Text', e.target.value)
                                    }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><NoteAlt /></InputAdornment> }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          )
                        }
                      </Grid>
                    )
                    : (
                      <Stack spacing={1}>
                        <Stack
                          direction={{
                            xs: 'column',
                            sm: 'row',
                          }}
                          spacing={1}
                          alignItems="flex-start"
                        >
                          {/* {(noteValue) && (horseNote
                            ? ( */}
                          <Paper
                            variant="outlined"
                            sx={{
                              flex: 1,
                              width: '100%',
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              if (completeDate || (horseNote && horseNote.id)) {
                                setOpenAddEditHorseNoteModal(true);
                                e.stopPropagation();
                                e.preventDefault();
                              } else {
                                setChangeNote(true)
                              }
                            }}
                          >
                            <NoteItemComponent
                              note={horseNote || {
                                type: noteTypeValue,
                                importance: noteImportanceValue,
                                clientViewable: noteClientViewableValue,
                                note: noteValue,
                                title: selectedEvent.name,
                              }}
                              divider={false}
                              hideActions
                              horseId={barnHorse.horse.id}
                              condensed
                              hideTask
                            />
                          </Paper>
                          {onChange && !horseNote && (
                            <Link
                              component="button"
                              variant="body2"
                              color="secondary"
                              underline="hover"
                              onClick={() => {
                                if (completeDate || (horseNote && horseNote.id)) {
                                  setOpenAddEditHorseNoteModal(true);
                                } else {
                                  setChangeNote(true)
                                }
                              }}
                            >
                              {horseNote || noteTypeValue
                                ? 'Modify'
                                : 'Add'}
                              {' '}
                              Horse Note
                            </Link>
                          )}
                        </Stack>
                      </Stack>

                    )
                }
              </ListItemText>
            )
            : (
              <ListItemText primaryTypographyProps={{ fontWeight: 300 }}>No Horse Note</ListItemText>
            )
        }

      </ListItem>
      <AddEditBillableModal
        open={openAddEditHorseBillableModal}
        billable={horseBillable || null}
        onClose={(didAddOrUpdate) => {
          setOpenAddEditHorseBillableModal(false);
          if (didAddOrUpdate) {
            dispatch(getBillableForTask(barnHorse.horse.id, selectedEvent.id));
          }
        }}
        navigate={() => { }}
        task={selectedEvent}
        horses={[barnHorse]}
        barnHorse={barnHorse}
        horseId={(barnHorse && barnHorse.id && barnHorse.horse.id) || null}
        billableDate={selectedEvent.completeDate || selectedEvent.startDate}
        billableDescription={selectedEvent.name}
        billableTaskTypeId={selectedEvent.eventTemplateId}
        disableHorseTaskLookup
      />
      <AddEditModal
        open={openAddEditHorseNoteModal}
        horseNote={horseNote || null}
        presetType={null}
        horseId={barnHorse.horse.id}
        pinnedHorseNoteId={(barnHorse && barnHorse.horse.activeNote)
          ? barnHorse.horse.activeNote.id
          : null}
        onClose={() => {
          setOpenAddEditHorseNoteModal(false);
          dispatch(getNoteForTask(barnHorse.horse.id, selectedEvent.id))
        }}
        taskId={selectedEvent.id}
      />
    </Box>
  );
}

EditTaskEventDataComponent.propTypes = {
  onChange: PropTypes.func,
  taskEventData: PropTypes.object,
  completeDate: PropTypes.any,
  selectedEvent: PropTypes.object,
  barnHorse: PropTypes.object,
  showDivider: PropTypes.bool,
};

EditTaskEventDataComponent.defaultProps = {
  onChange: null,
  taskEventData: null,
  completeDate: new Date(),
  selectedEvent: {},
  barnHorse: {},
  showDivider: true,
};

export default EditTaskEventDataComponent;
